<template>
  <div>
    <fieldset>
      <legend class="text-blue ts-font-robot">
        {{ $t('promotion.condition') }}
        <Tooltip placement="top">
          <Icon type="ios-information-circle-outline" size="17" />
          <div slot="content">
            <div class="ts-text-xs">
              {{ $t('promotion.condition') }}
            </div>
          </div>
        </Tooltip>
      </legend>
      <div class="overflow-auto ts-max-h-40">
        <ByProduct v-model="model" :validate="errors" />
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import ByProduct from './discount-by-range/by-product.vue'
export default {
  name: 'discount-by-range-condition',
  props: ['value', 'validate'],
  components: {
    ByProduct,
  },
  data() {
    return {
      errors: new Errors(),
      show_apply_all: false,
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('promotion/discountByRange', ['formViewDatas']),
  },
  methods: {
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>